import React, { useEffect, useState } from 'react';
import './platformMajPictureZoom.css';
import platformMajPictureZoomDto from '../template/homeGhajari3AboutTemplate';
import { Box } from '@mui/material';
import { languageData } from '../showExperienceWithScroll/Experience';

export interface PlatformMajPictureZoomProps {
  scrollY: number;
  windowSize: {
    width: number;
    height: number;
  };
  item: platformMajPictureZoomDto;
}

const PlatformMajPictureZoom: React.FC<PlatformMajPictureZoomProps> = ({
  scrollY,
  windowSize,
  item,
}) => {
  const sectionId = `pmAnimationLogo${item.id}`;

  const [height] = useState(item.length * item.distance - item.distance);
  const [justifyContent, setJustifyContent] = useState<'flex-start' | 'flex-end'>('flex-start');
  const [position, setPosition] = useState<'fixed' | 'relative'>('fixed');
  const [frame, setFrame] = useState({ width: windowSize.width, height: windowSize.height, borderWidth: 0, borderHeight: 0 });
  const [filterGrayscale, setFilterGrayscale] = useState(0);

  const startItem = () => document.getElementById(sectionId)?.offsetTop ?? 0;
  const endItem = () => startItem() + height;
  const scrollWithinSection = () => scrollY - startItem();
  const scrollItemIndex = () => Math.floor(scrollWithinSection() / item.distance) - 1;

  const itemScrollHeight = () => height + windowSize.height;

  const minSizeFrame = item.minSizeFrame;
  const maxSizeFrame = windowSize;

  const distance = {
    width: (maxSizeFrame.width - minSizeFrame.width) / item.length,
    height: (maxSizeFrame.height - minSizeFrame.height) / item.length,
  };

  const calculateFrame = (step: number) => {
    const width = maxSizeFrame.width - step * distance.width;
    const height = maxSizeFrame.height - step * distance.height;
    const borderWidth = (step * distance.width) / 2 + 0.5;
    const borderHeight = (step * distance.height) / 2 + 1;

    return { width, height, borderWidth, borderHeight };
  };

  const handleMinFrame = () => calculateFrame(item.length - 2);
  const handleMaxFrame = () => ({ width: windowSize.width, height: windowSize.height, borderWidth: 0, borderHeight: 0 });

  const isVisible = () =>
    scrollY >= startItem() + 200 && scrollY <= endItem() + windowSize.height;

  useEffect(() => {
    const start = startItem();
    const end = endItem();

    if (scrollY < start) {
      setPosition('relative');
      setJustifyContent('flex-start');
      setFrame(handleMaxFrame());
      setFilterGrayscale(0);
    } else if (scrollY > end) {
      setPosition('relative');
      setJustifyContent('flex-end');
      setFrame(handleMinFrame());
      setFilterGrayscale(100);
    } else {
      setPosition('fixed');
      setJustifyContent('flex-start');
      setFrame(calculateFrame(scrollItemIndex()));
      setFilterGrayscale(((scrollItemIndex() + 3) * 100) / item.length);
    }
  }, [scrollY, windowSize]);

  return (
    <div
      className="pmItemScrollContainer"
      id={sectionId}
      style={{
        position: 'relative',

        height: itemScrollHeight(),
        minHeight: itemScrollHeight(),

        display: 'flex',
        flexDirection: 'column',
        justifyContent,
      }}
    >
      {(item.title || item.description) && (
        <Box
          sx={{
            backgroundColor: '#dde3e1',
            borderRadius: '10px'
          }}
          className="pmPictureZoomTitle">
          {item.title && <h2>{item.title}</h2>}
          <div dangerouslySetInnerHTML={{ __html: item.description }} />
          <Box gap={2} p={1} display='flex' flexWrap='wrap' justifyContent='center' alignItems='center' >
            {languageData.map((item, index) =>
              <img
                key={index}
                src={`${process.env.PUBLIC_URL}/languages/${item.id}.png`}
                alt={`Logo frame ${index}`}
                style={{

                  width: '40px',
                  height: 'auto',
                }}
              />
            )}
          </Box>
        </Box>
      )}

      <div
        className="pmItemContainer pmPictureZoomContainer"
        style={{
          position,
          height: windowSize.height,
          backgroundImage: `url(/${item.id}${item.fileFormat})`,
          filter: `grayscale(${filterGrayscale}%)`,
          WebkitFilter: `grayscale(${filterGrayscale}%)`,
        }}
      >
        {isVisible() && (
          <>
            <div
              className="pmPictureZoomFrame"
              style={{
                width: frame.width,
                height: frame.height,
                borderWidth: `${frame.borderHeight}px ${frame.borderWidth}px`,
                borderColor: item.backColor,
                zIndex: 2,
              }}
            />
            <div
              className="pmPictureZoomFrame2"
              style={{
                width: frame.width,
                height: frame.height,
                borderWidth: '20px',
                borderColor: item.backColor,
                borderRadius: '40px',
                borderStyle: 'solid',
                zIndex: 3,
                top: frame.borderHeight - 20,
                left: frame.borderWidth - 20,
              }}
            />
          </>
        )}

        {item.logo && (
          <img
            src={item.logo}
            alt="Zoom logo"
            style={{
              width: 250,
              height: 250,
              opacity: scrollY > startItem() + 400 ? 1 : 0,
              transition: '1s',
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PlatformMajPictureZoom;